module.exports = __webpack_public_path__ + "media/fonts/Roboto-Thin-c38fab23fc1c36894f10dd8014479b53.ttf";